import './StatusPill.scss';
import { ClientRequestStatusMap, ReviewerStatusMap } from '../../Models/Maps';
import React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { GridRenderCellParams } from '@mui/x-data-grid/models/params/gridCellParams';

type StatusPillProps = {
  status: string,
  backgroundColor?: string,
  dotColor?: string,
  displayText?: string
}

export const StatusPill = (
  { status, backgroundColor, dotColor, displayText }: StatusPillProps
) => {
  const combinedMap = { ...ClientRequestStatusMap, ...ReviewerStatusMap };
  const statusKey = status ? Object.keys(combinedMap).find(key => key.toLowerCase() === status.toLowerCase()) : null;
  const statusConfig = statusKey ? combinedMap[statusKey] : null;

  return (
    <div className="status-pill" style={{ backgroundColor: backgroundColor || statusConfig?.backgroundColor || '#F0F2F5' }}>
      <div className="status-dot" style={{ backgroundColor: dotColor || statusConfig?.dotColor || '#879AAB' }}></div>
      <span>{displayText || status}</span>
    </div>
  )
}

type SecondaryStatusPillProps = {
  icon: React.ReactNode,
  label: string,
}

// "Secondary" status pill from the design system — icon + label on a bordered white background,
// used for auxiliary states layered on top of a primary StatusPill (e.g. Hold).
export const SecondaryStatusPill = ({ icon, label }: SecondaryStatusPillProps) => (
  <div className="secondary-status-pill">
    <span className="secondary-status-pill__icon">{icon}</span>
    <span className="secondary-status-pill__label">{label}</span>
  </div>
);

export interface ReferralStatusCellProps extends GridCellProps {
  onClick?: () => void;
}

export const referralStatusCell: React.FC<ReferralStatusCellProps> = (
  props: ReferralStatusCellProps
) => {
  return (
    <td onClick={props.onClick}>
      <StatusPill
        status={
          props.dataItem.openReferralType === 'Submitted'
            ? props.dataItem.openReferralType
            : props.dataItem.status
        }
      />
    </td>
  );
};

export interface DraftReferralStatusCellProps extends GridCellProps {
  onClick?: () => void;
}

export const draftReferralStatusCell: React.FC<DraftReferralStatusCellProps> = (
  props: DraftReferralStatusCellProps
) => {
  return (
    <td onClick={props.onClick}>
      <StatusPill
        status={props.dataItem.status.displayName}
      />
    </td>
  );
};

export interface AppointmentStatusCellProps extends GridCellProps {
  onClick?: () => void;
}

export const appointmentStatusCell: React.FC<AppointmentStatusCellProps> = (
  props: AppointmentStatusCellProps
) => {
  return (
    <td onClick={props.onClick}>
      <StatusPill
        status={
          props.dataItem.appointment?.appointmentStatus?.displayName ??
          props.dataItem.appointmentStatus?.displayName
        }
      />
    </td>
  );
};

export interface ReviewerStatusCellProps extends GridRenderCellParams {
  onClick?: () => void;
}

export const ReviewerStatusCell: React.FC<ReviewerStatusCellProps> = (
  props: ReviewerStatusCellProps
) => {
  return (
    <div onClick={props.onClick}>
      <StatusPill status={props.value} />
    </div>
  );
};